/**
 * Social media post lifecycle statuses (`social_media_posts.status`).
 *
 * Backed by a Postgres CHECK constraint on `social_media_posts`. Verified
 * against production: draft, scheduled, publishing, posted, partially_failed,
 * failed, canceled. Use `z.enum(SOCIAL_POST_STATUS_VALUES)` — never a local
 * literal duplicate.
 */

export const SOCIAL_POST_STATUS_VALUES = [
  "draft",
  "scheduled",
  "publishing",
  "posted",
  "partially_failed",
  "failed",
  "canceled",
] as const;

export type SocialPostStatus = (typeof SOCIAL_POST_STATUS_VALUES)[number];
